import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";

const CustomFieldChoicesCard = ({data}) => {
  const {description = "", name = "", order_alphabetically = false} = data;

  return (
    <CardBody>
      <CardTitle tag="h3">{name} </CardTitle>
      <CardText>{`Description: ${description}`}</CardText>
      <CardText>
        Order Alphabetically:
        <Badge color="" className="badge-dot ml-2">
          {order_alphabetically ? (
            <i className="bg-success" />
          ) : (
            <i className="bg-warning" />
          )}
        </Badge>
      </CardText>
    </CardBody>
  );
};

export default CustomFieldChoicesCard;
